import styled from '@emotion/styled';

export const CheckboxContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  label {
    ${({ theme }) => theme.text.body1};
  }
`;
